"use client";
import React from "react";
import ToolButton from "./ToolButton";
import useScreenSize from "../hooks/useScreenSize";
import ResponsiveComponent from "../ResponsiveComponent";
import { motion } from "framer-motion";

export const BtnList = [
  { name: "Git", iconUrl: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" },
  { name: "Docker", iconUrl: "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png" },
  { name: "Google Cloud Platform", iconUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwVi6Iv9zNSlRu8OhdHbNecdZk1qWTbJDepw&s" },
  { name: "MongoDB", iconUrl: "https://www.mongodb.com/assets/images/global/favicon.ico" },
  { name: "Swift", iconUrl: "https://cdn.worldvectorlogo.com/logos/swift-15.svg" },
  { name: "Kotlin", iconUrl: "https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.svg" },
  { name: "Xcode", iconUrl: "https://developer.apple.com/assets/elements/icons/xcode/xcode-96x96.png" },
  { name: "WebSockets", iconUrl: "https://socket.io/images/logo-dark.svg" },
  { name: "LLMs", iconUrl: "https://pngdownload.io/wp-content/uploads/2023/12/ChatGPT-Logo-Advanced-Language-Generation-PNG-Transparent-Innovative-Design-jpg.webp" },
  { name: "VS Code", iconUrl: "https://code.visualstudio.com/favicon.ico" },
  { name: "Figma", iconUrl: "https://cdn.sanity.io/images/599r6htc/regionalized/46a76c802176eb17b04e12108de7e7e0f3736dc6-1024x1024.png?w=804&q=75&fit=max&auto=format&dpr=2" }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const Tools = () => {
  const angleIncrement = 360 / BtnList.length;
  const size = useScreenSize();
  const isLarge = size >= 1024;
  const isMedium = size >= 768;

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <ResponsiveComponent>
        {({ size }) => {
          return size && size >= 480 ? (
            <motion.div
              variants={container}
              initial="hidden"
              animate="show"
              className="w-max flex items-center justify-center relative hover:pause animate-spin-slow group"
            >
              {BtnList.map((btn, index) => {
                const angleRad = (index * angleIncrement * Math.PI) / 180;
                const radius = isLarge
                  ? "calc(16vw - 1rem)"
                  : isMedium
                  ? "calc(14vw - 1rem)"
                  : "calc(12vw - 1rem)";
                const x = `calc(${radius}*${Math.cos(angleRad)})`;
                const y = `calc(${radius}*${Math.sin(angleRad)})`;

                return <ToolButton key={btn.name} x={x} y={y} {...btn} />;
              })}
            </motion.div>
          ) : (
            <>
              <motion.div
                variants={container}
                initial="hidden"
                animate="show"
                className="w-full px-2.5 xs:p-0 xs:w-max flex flex-col space-y-4 item-start xs:items-center justify-center relative  group xs:hidden"
              >
                {BtnList.slice(0, BtnList.length / 2).map((btn) => (
                  <ToolButton key={btn.name} x={0} y={0} {...btn} />
                ))}
              </motion.div>

              <motion.div
                variants={container}
                initial="hidden"
                animate="show"
                className="w-full px-2.5 xs:p-0 xs:w-max flex flex-col space-y-4 items-end xs:items-center justify-center relative group xs:hidden"
              >
                {BtnList.slice(BtnList.length / 2, BtnList.length).map((btn) => (
                  <ToolButton
                    key={btn.name}
                    x={0}
                    y={0}
                    {...btn}
                    labelDirection="left"
                  />
                ))}
              </motion.div>
            </>
          );
        }}
      </ResponsiveComponent>
    </div>
  );
};

export default Tools;
